import module from 'contabilidad/polizasexternas/module'
import template from './template.html'

export class ContabilidadPolizasexternasComponent {
  editando = false
  polizasLNF
  polizasAG
  polizasES
  permisos

  constructor(PolizasExternasPermisosService) {
    this.PolizasExternasPermisosService = PolizasExternasPermisosService
    this.polizasLNF = [
      { ruta: '.provisioncompras()', label: 'Provisión de compras' },
      { ruta: '.provisioncomprasbo()', label: 'Provisión de compras BackOffice' },
      { ruta: '.provisioncompraspagos()', label: 'Provisión de compras pagos' },
      { ruta: '.provisioningresos()', label: 'Provisión de Ingresos' },
      { ruta: '.provisionnominasconpagossucursales', label: 'Provisión Nóminas con pagos Por Sucursal' },
      { ruta: '.costoventa()', label: 'Costo de venta' },
      { ruta: '.cobranza()', label: 'Cobranza' },
    ]

    this.polizasAG = [
      { ruta: '.provisioningresosag()', label: 'Provisión de Ingresos' },
      { ruta: '.provisioncomprasag()', label: 'Provisión de Compras' },
      { ruta: '.ingresos()', label: 'Póliza Ingresos' },
      { ruta: '.costoventaag()', label: 'Póliza Costo de venta' },
      { ruta: '.algpagosgastos()', label: 'Póliza Pagos gastos' },
      { ruta: '.algpagoscompras()', label: 'Póliza Pagos compras' },
      { ruta: '.traspasosag()', label: 'Póliza Traspasos' },
    ]

    this.polizasES = [
      { ruta: '.costoventaag()', label: 'Costo de venta' },
      { ruta: '.provisioncomprasag()', label: 'Provisión de compras' },
      { ruta: '.provisioncomprasboag()', label: 'Provisión de compras BackOffice' },
      { ruta: '.provisioncompraspagosag()', label: 'Provisión de compras pagos' },
      { ruta: '.provisioningresosag()', label: 'Provisión de Ingresos' },
      { ruta: '.traspasosag()', label: 'Traspasos' },
    ]
  }

  $onInit () {
    this.promise = this.PolizasExternasPermisosService.get()
      .then(({ data }) => (this.permisos = data))
  }
}

module.component('contabilidadPolizasexternas', {
  controller: ContabilidadPolizasexternasComponent,
  template,
})


// WEBPACK FOOTER //
// ./src/contabilidad/polizasexternas/components/component.js